module.exports = __webpack_public_path__ + "media/images/ringrevenue/button_right-25c82f0e478a9c6a3ee230e3252d7435.png";